import React from 'react';
import GlassCard from '../../customs/GlassCard';
import styles from './SponsorDropoff.module.css';
import ChildInfoOnCard from '../../child/ChildInfoOnCard';

const ChildCard = ({ child, dropoffScreen = false }) => {
  return (
    <GlassCard className={styles.card}>
      <ChildInfoOnCard child={child} dropoffScreen={dropoffScreen} />
    </GlassCard>
  );
};

export default ChildCard;
